module.exports = __webpack_public_path__ + "img/20200610_160043.69c7c1da.jpg";